module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lowData) ? _c('svg', {
    attrs: {
      "width": "20",
      "height": "20"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "r": "9",
      "stroke-width": "1",
      "stroke": "black",
      "fill": "white"
    }
  })]) : (_vm.mediumData) ? _c('svg', {
    attrs: {
      "width": "20",
      "height": "20"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "r": "9",
      "stroke-width": "1",
      "stroke": "black",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M 17 10 A 1 1 1 0 1 3 10",
      "fill": "black"
    }
  })]) : (_vm.goodData) ? _c('svg', {
    attrs: {
      "width": "20",
      "height": "20"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "r": "9",
      "stroke-width": "1",
      "stroke": "black",
      "fill": "white"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "r": "6",
      "stroke-width": "1",
      "stroke": "black",
      "fill": "black"
    }
  })]) : (_vm.notApplicable) ? _c('svg', {
    attrs: {
      "width": "20",
      "height": "20"
    }
  }, [_c('line', {
    attrs: {
      "x1": "1",
      "x2": "19",
      "y1": "10",
      "y2": "10",
      "stroke-width": "3",
      "stroke": "black"
    }
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01d9981a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataAvailabilityIndicator.vue
// module id = 140
// module chunks = 1